// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";



// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC8p_xbwLt1zWJur7bc4055_gkPTaq9XC8",
  authDomain: "myproject-26fc7.firebaseapp.com",
  projectId: "myproject-26fc7",
  storageBucket: "myproject-26fc7.firebasestorage.app",
  messagingSenderId: "201141043008",
  appId: "1:201141043008:web:a1581eefb80efbfc4a44a5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
auth.settings.appVerificationDisabledForTesting = true;

export { auth, provider, signInWithPopup, signOut };
